export default "__VITE_ASSET__CxJzP4HL__"